<template>
    <component
        :is="as"
        :class="['transition-height', { 'overflow-hidden': transitioning }]"
        :style="
            enabled
                ? {
                      height: height + 'px',
                      'transition-duration': currentDuration,
                  }
                : {}
        "
    >
        <div ref="child">
            <slot></slot>
        </div>
    </component>
</template>
<script>
import { debounce } from '@/Tools/utilities.js'
export default {
    props: {
        minHeight: {
            type: Number,
            default: 0,
        },
        duration: {
            type: String,
            default: '500ms',
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        as: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerHeight: 0,
            currentDuration: '0ms',
            transitioning: false,
        }
    },

    computed: {
        height() {
            return this.minHeight > this.containerHeight
                ? this.minHeight
                : this.containerHeight
        },
    },

    watch: {
        /**
         * Toggle the resize observer based on the enabled prop
         * This is used to prevent the resize observer from doing unnecessary work
         */
        enabled() {
            if (this.enabled) {
                this.resizeObserver.observe(this.$refs.child)
            } else {
                this.resizeObserver.disconnect()
            }
        },
    },

    created() {
        this.debouncedHandleResize = debounce(() => {
            this.handleResize()
        }, 100)
    },

    mounted() {
        this.$nextTick(() => {
            let callback = () => (this.currentDuration = this.duration)
            this.handleResize(callback)
        })

        this.resizeObserver = new ResizeObserver(this.debouncedHandleResize)
        if (this.enabled) {
            this.resizeObserver.observe(this.$refs.child)
        }
    },

    beforeUnmount() {
        this.resizeObserver?.disconnect()
    },

    methods: {
        handleResize(callback = null) {
            this.transitioning = true
            this.$nextTick(() => {
                if (this.$refs.child) {
                    this.containerHeight = this.$refs.child.scrollHeight
                }
                setTimeout(() => {
                    this.transitioning = false
                    this.$emit('transitionDone')
                    if (callback) callback()
                }, 300) // Adjust the timeout duration as needed
            })
        },

        debouncedHandleResize: debounce(
            function () {
                this.handleResize()
            }.bind(this),
            200
        ), // Adjust the debounce delay as needed
    },
}
</script>
